import PendoToggle from '../../components/toggle/pendo-toggle.vue.js';
import PendoCard from '../../components/card/pendo-card.vue.js';
import camelCase from 'lodash/camelCase.js';
import startCase from 'lodash/startCase.js';
import cloneDeep from 'lodash/cloneDeep.js';
import isEmpty from 'lodash/isEmpty.js';
import get from 'lodash/get.js';

var script = {
  name: 'PendoSuggestedPagesTable',
  components: {
    PendoCard,
    PendoToggle
  },
  props: {
    userPreferences: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  computed: {
    showCard() {
      return !isEmpty(this.userPreferences);
    },
    userPreferencesMap() {
      const userPreferencesClone = cloneDeep(this.userPreferences);
      return Object.fromEntries(Object.entries(userPreferencesClone).map(_ref => {
        let [preferenceKey, preferenceValue] = _ref;
        if (preferenceValue.subSettings) {
          Object.fromEntries(Object.entries(preferenceValue.subSettings).map(_ref2 => {
            let [subSettingKey, subSettingValue] = _ref2;
            subSettingValue.value = preferenceValue.value ? subSettingValue.value : preferenceValue.value;
            subSettingValue.disabled = this.subSettingDisabled(preferenceValue, subSettingValue);
            return [subSettingKey, subSettingValue];
          }));
        }
        return [preferenceKey, preferenceValue];
      }));
    }
  },
  methods: {
    subSettingDisabled(preferenceValue, subSettingValue) {
      return preferenceValue.disabled || !preferenceValue.value ? true : subSettingValue.disabled;
    },
    handleToggleChange(preference, value) {
      let parentPreferencekey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      const userPreferencesClone = cloneDeep(this.userPreferences);
      if (parentPreferencekey) {
        userPreferencesClone[parentPreferencekey].subSettings[preference].value = value;
      } else {
        userPreferencesClone[preference].value = value;
        if (!isEmpty(get(userPreferencesClone[preference], 'subSettings', false))) {
          Object.fromEntries(Object.entries(userPreferencesClone[preference].subSettings).map(_ref3 => {
            let [subSettingKey, subSettingValue] = _ref3;
            subSettingValue.value = subSettingValue.disabled ? false : subSettingValue.value = value;
            return [subSettingKey, subSettingValue];
          }));
        }
      }
      this.$emit('toggle-change', userPreferencesClone);
    },
    labelFormat(preferenceValue, preferenceKey) {
      return preferenceValue.displayName || startCase(camelCase(preferenceKey));
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-user-preferences.vue2.js.map
